import React from 'react';
import utils from '@/common/utils';
import ComponentLog from '@/components/component-log';
import { Tooltip } from 'antd';

const SalesList = (props) => {
  const { btnText = '', salesList = [], toSignup = () => {} } = props;
  return (
    <div className="myTodoList">
      {salesList.map((item, index) => (
        <div key={index} className="MyTodoList-item">
          {item.activityName ? (
            <>
              <div className="areaName-wrap">
                <Tooltip placement="topLeft" title={item.activityName}>
                  <div className="areaName-wrap-text">{item.activityName}</div>
                </Tooltip>
                <span className="text">活动ID：{item.planCode}</span>
              </div>
              <div className="session-signup-endTime-wrap">
                <div className="name">活动报名时间：</div>
                <div className="text">
                  {utils.enhancedFormateTimeStamp(item.businessStartTime)} 至{' '}
                  {utils.enhancedFormateTimeStamp(item.businessEndTime)}
                </div>
              </div>
              <div className="deadline-wrap">
                <div className="name">报名剩余时长{utils.remainingHoursAndMin(item.cutOffTime)}</div>
              </div>
              <div className="goCheck-wrap">
                <ComponentLog>
                  <div clstag="resource_1627030927203|38" className="name" onClick={() => toSignup(item)}>
                    {btnText}
                  </div>
                </ComponentLog>
              </div>
            </>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default SalesList;
